import classificacaoTributaria from "./classificacaoTributaria";

const OpcoesTributarias = {
    codigoOpcaoSimplesNacional: [
        { content: 'Não Optante', id: '1' },
        { content: 'Optante - Microempreendedor Individual (MEI)', id: '2' },
        { content: 'Optante - Microempresa ou Empresa de Pequeno Porte (ME/EPP)', id: '3' },
    ],

    tipoTributacao: [
        { content: 'Operação tributável', id: '1' },
        { content: 'Imunidade', id: '2' },
        { content: 'Exportação de serviço', id: '3' },
        { content: 'Não Incidência', id: '4' },
    ],

    regimeApuracaoTributariaSimplesNacional: [
        { content: 'Federais e municipal pelo SN', id: '1' },
        { content: 'Federais pelo SN e ISSQN pela NFS-e municipal', id: '2' },
        { content: 'Federais e municipal pela NFS-e', id: '3' },
    ],

    regimeEspecialTributacaoMunicipal: [
        { content: 'Nenhum', id: '0' },
        { content: 'Ato Cooperado', id: '1' },
        { content: 'Estimativa', id: '2' },
        { content: 'Microempresa Municipal', id: '3' },
        { content: 'Notário ou Registrador', id: '4' },
        { content: 'Profissional Autônomo', id: '5' },
        { content: 'Sociedade de Profissionais', id: '6' },
    ],

    situacaoTributariaPisCofins: [
        { content: 'Operação Tributável com Alíquota Básica', id: '1' },
        { content: 'Operação Tributável com Alíquota Diferenciada', id: '2' },
        { content: 'Operação Tributável com Alíquota por Unidade de Medida de Produto', id: '3' },
        { content: 'Operação Tributável monofásica - Revenda a Alíquota Zero', id: '4' },
        { content: 'Operação Tributável por Substituição Tributária', id: '5' },
        { content: 'Operação Tributável a Alíquota Zero', id: '6' },
        { content: 'Operação Tributável da Contribuição', id: '7' },
        { content: 'Operação sem Incidência da Contribuição', id: '8' },
        { content: 'Operação com Suspensão da Contribuição', id: '9' },
    ],

    optanteSimplesNacional: [
        { content: 'Não', id: false },
        { content: 'Sim', id: true },
    ],

    regimeTributario: [
        { content: 'Simples Nacional', id: '1' },
        { content: 'Simples Nacional - Excesso de Sublimite de Receita Bruta', id: '2' },
        { content: 'Regime Normal', id: '3' },
        { content: 'Simples Nacional - Microempreendedor Individual - MEI', id: '4' },
    ],

    regimeTributarioEspecial: [
        { content: 'Nenhum', id: '0' },
        { content: 'Microempresa Municipal', id: '1' },
        { content: 'Estimativa', id: '2' },
        { content: 'Sociedade de Profissionais', id: '3' },
        { content: 'Cooperativa', id: '4' },
        { content: 'MEI - Simples Nacional', id: '5' },
        { content: 'ME EPP- Simples Nacional', id: '6' },
    ],

    incentivadorCultural: [
        { content: 'Não', id: false },
        { content: 'Sim', id: true },
    ],

    naturezaOperacao: [
        { content: 'Tributação no Município', id: '1' },
        { content: 'Tributação fora do Município', id: '2' },
        { content: 'Isenção', id: '3' },
        { content: 'Imune', id: '4' },
        { content: 'Exigibilidade Suspensa por Decisão Judicial', id: '5' },
        { content: 'Exigibilidade Suspensa por Procedimento Administrativo', id: '6' },
    ],

    codigoIndicadorOperacao: [
        { content: "Nenhum", id: "0" },
        { content: "010101 - Bem Móvel Material - Presencial, com retirada no estabelecimento do fornecedor", id: "010101" },
        { content: "010102 - Bem Móvel Material - Presencial, com retirada fora do estabelecimento do fornecedor", id: "010102" },
        { content: "010103 - Bem Móvel Material - Não presencial, com entrega ou disponibilização em endereço fornecido", id: "010103" },
        { content: "010104 - Bem Móvel Material - Licitação promovida pelo poder público de bem apreendido ou abandonado ou leilão judicial", id: "010104" },
        { content: "010105 - Bem Móvel Material - Constatação de irregularidade pela falta de documentação fiscal", id: "010105" }
    ],

    tributacaoIBSCBS: [
        { content: "Nenhum", id: "0" },
        { content: "000 - Tributação integral", id: "000" },
        { content: "010 - Tributação com alíquotas uniformes", id: "010" },
        { content: "011 - Tributação com alíquotas uniformes reduzidas", id: "011" },
        { content: "200 - Alíquota reduzida", id: "200" },
        { content: "220 - Alíquota fixa", id: "220" },
        { content: "221 - Alíquota fixa proporcional", id: "221" },
        { content: "222 - Redução de Base de Cálculo", id: "222" },
        { content: "400 - Isenção", id: "400" },
        { content: "410 - Imunidade e não incidência", id: "410" },
        { content: "510 - Diferimento", id: "510" },    
        { content: "515 - Diferimento com redução de alíquota", id: "515" },
        { content: "550 - Suspensão", id: "550" },
        { content: "620 - Tributação Monofásica", id: "620" },
        { content: "800 - Transferência de crédito", id: "800" },
        { content: "810 - Ajuste de IBS na ZFM", id: "810" },
        { content: "811 - Ajustes", id: "811" },
        { content: "820 - Tributação em documento específico", id: "820" },
        { content: "830 - Exclusão da Base de Cálculo", id: "830" }
    ],

    classificacaoTributaria,
};

export default Object.freeze(OpcoesTributarias);
